import React from "react";
import { FormGroup, Input, Label } from "reactstrap";
import { ErrorMessage } from "formik";

const FormikCheckboxField = ({
  field: { ...fields },
  form: { touched, errors },
  ...props
}) => {
  const { id, label } = props;
  const { name } = fields;
  return (
    <FormGroup className="flex-grow-1">
      <Label for={id} className="label-color">
        <Input
          {...props}
          {...fields}
          className="me-2"
          invalid={Boolean(touched[name] && errors[name])}
        />
        {label}
      </Label>
      <ErrorMessage
        name={fields.name}
        render={(msg) => <div className="text-danger font-size-12">{msg}</div>}
      />
    </FormGroup>
  );
};
export default FormikCheckboxField;
